import Settings from './settings';
import MyProfile from './myProfile';
import ChangePassword from './changePassword';

// Module
import routes from './routes';
import Service from './service';

export default angular.module( 'app.main.account.module',
    [
	    Settings,
		MyProfile,
	    ChangePassword
    ] )
    .config(routes)
	.service('AccountService', Service)
    .name



/** WEBPACK FOOTER **
 ** ./src/main/account/index.js
 **/